import React from "react";
import Modal from "react-bootstrap/Modal";

import "./modalComponent.css";

function ModalComponent({
  title,
  bodyContent,
  footerContent,
  onHide,
  size = "lg",
  centered = true,
  show,
}) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size={size}
      aria-labelledby="contained-modal-title-vcenter"
      centered={centered}
      className="modal-wrap">
      <Modal.Header closeButton>
        <Modal.Title className="header-wrap" id="contained-modal-title-vcenter">
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-body-wrap">{bodyContent}</div>
      </Modal.Body>
      <Modal.Footer>
        <div className="footer-wrap w-100">{footerContent}</div>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalComponent;
